import { imageSrcSet, resizedImageUrl } from "@majourneys/shared";
import type { DiscoverItem } from "../../types";

export function hasImage(item: Pick<DiscoverItem, "image">): boolean {
  return typeof item.image === "string" && item.image.trim().length > 0;
}

// Marker and card thumbnails are square crops, so `fit=cover`. Hosts we cannot
// resize (Unsplash, Wikimedia, venue sites) come back untouched.
export function thumbUrl(url: string, size: number): string {
  if (!url) return url;
  return resizedImageUrl(url, size, { fit: "cover" });
}

// `srcSet` counterpart of `thumbUrl`: lets the browser pick the smallest
// candidate that covers rendered size × device pixel ratio. `undefined` for
// hosts we cannot resize so callers omit the attribute.
export function thumbSrcSet(url: string, widths: readonly number[]): string | undefined {
  if (!url) return undefined;
  return imageSrcSet(url, widths, { fit: "cover" });
}
